<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>用户登录时间</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-form 
        ref="form"
        :model="searchForm"
        label-width="80px"
        :inline="true"
        size="small"
        class="admin_from">

        <el-form-item
          label=""
          :class="
            this.$store.state.windowWidth <= this.$store.state.MaxWidth
              ? 'maxWidth'
              : ''
          ">
          <el-input
            v-model="searchForm.userid"
            placeholder="请输入用户ID"
          ></el-input>
        </el-form-item>


        <el-form-item label="">
            <el-col :span="11">
                <el-form-item prop="date1">
                    <el-date-picker type="date" placeholder="选择日期" v-model="searchForm.start_time"
                                    value-format="yyyy-MM-dd"
                                    style="width: 100%;"></el-date-picker>
                </el-form-item>
            </el-col>
            <el-col class="line" :span="1">-</el-col>
            <el-col :span="11">
                <el-form-item prop="date1">
                    <el-date-picker type="date" placeholder="选择日期" v-model="searchForm.end_time"
                                    value-format="yyyy-MM-dd"
                                    style="width: 100%;"></el-date-picker>
                </el-form-item>
            </el-col>
        </el-form-item>

          <el-form-item>
            <el-button type="primary" size="small" @click="addRecharge" style="display: none;" >添加CDK</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="search">查询</el-button>
            <el-button type="primary" @click="exportToExcel()" style="margin-left:20px;" class="el-icon-s-marketing"> 导出excel </el-button>
          </el-form-item>

      </el-form>
      <el-table size="small" :data="tableData" border style="width: 100%">

        <el-table-column label="用户ID">
          <template slot-scope="scope">
            {{ scope.row.userid }}
          </template>
        </el-table-column>

        <el-table-column label="登录时间">
          <template slot-scope="scope">
            {{ scope.row.create_date }}
          </template>
        </el-table-column>
        
      </el-table>
      <div class="el-pagination">
        <el-pagination
            background
            @size-change="changeSize"
            @current-change="changeCurrent"
            :current-page="params.page_num"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="params.pagesize"
            :layout="this.$store.state.paginationLayout"
            :total="params.totals"
        >
        </el-pagination>
      </div>
    </el-card>
    <!-- 新增或编辑 -->
    <el-dialog :title="fromTitle" :width="this.$store.state.dialogWidth" :visible.sync="visible">
      <el-row :gutter="20">
        <el-col :span="this.$store.state.elColNum">
          <el-form ref="form" :label-width="this.$store.state.labelWidth" size="small">
            <el-form-item label="卡号" v-if="this.id">
              <el-input v-model="dataForm.card"></el-input>
            </el-form-item>
            <el-form-item label="添加数量(个)" v-if="!this.id">
              <el-input v-model="dataForm.num"></el-input>
            </el-form-item>
            <el-form-item label="有效时长(天)">
              <el-input v-model="dataForm.valid_time"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="dialogAffirm" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "User",
  data() {
    return {
      params: {
        page_num: 1,
        page_size: 10,
        totals: 0,
      },
      dataForm: {
        num: '',
        card: '',
        valid_time: ''
      },
      searchForm: {
        userid: '',
        start_time: '',
        end_time: '',
      },
      tableData: [],
      fromTitle: '',
      visible: false,
      id: '',
    };
  },
  created() {
    this.getList();
  },
  filters: {
    status: function (status) {
      //return status === 0 ? '已使用' : '未使用';
    }
  },
  methods: {
    getList() {
      let data = {
        page: this.params.page_num,
        page_size: this.params.page_size,
        userid:this.searchForm.userid,
        start_time:this.searchForm.start_time,
        end_time:this.searchForm.end_time,
      };
      this.$axios.post('admin/cdk/index', data).then(res => {
        this.params.totals = parseInt(res.data.count);
        this.tableData = res.data.list;
      });
    },
    changeSize(val) {
      this.params.page_size = val;
      this.getList();
    },
    changeCurrent(val) {
      this.params.page_num = val;
      this.getList();
    },
    addRecharge() {
      this.fromTitle = '新增';
      this.id = '';
      this.dataForm = {
        num: '',
        card: '',
        valid_time: ''
      };
      this.visible = true;
    },
    edit(id) {
      this.id = id;
      this.fromTitle = '编辑';
      this.$axios.get('admin/cdk/' + id).then(res => {
        this.dataForm = res.data;
        this.visible = true;
      });
    },
    dialogAffirm() {
      if (this.id) {
        this.$axios.put('admin/cdk/' + this.id, this.dataForm).then(res => {
          this.$message.success('成功');
          this.getList();
          this.visible = false;
        });
      } else {
        this.$axios.post('/admin/cdk', this.dataForm).then(res => {
          this.$message.success('成功');
          this.getList();
          this.visible = false;
        });
      }
    },
    remove(id) {
      this.$confirm('确定要进行操作, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$axios.del('admin/cdk/destroy/' + id).then(res => {
          this.$message.success('删除成功!');
          this.getList();
        });
      }).catch(() => {
      });
    },
    exportToExcel() {
      let Exceldata = {
        userid: this.searchForm.userid,
        start_time: this.searchForm.start_time,
        end_time: this.searchForm.end_time,
      };
      this.$axios.post("admin/cdk/getexceluser", Exceldata).then((val) => {
            console.log(val);
            this.exportList = val.data.list
            require.ensure([],()=>{
                const{
                    export_json_to_excel
                } = require('../../excel/Export2Excel');
                const tHeader = ['用户ID','登录时间'];
                const filterVal  = ['userid','create_date'];
                const list = this.exportList;
                const data = this.formatJson(filterVal,list);
                export_json_to_excel(tHeader,data,'用户登录时间_excel');
            })
        });
    },
    formatJson(filterVal,jsonData){
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    search() {
      this.params.page_num = 1;
      this.getList();
    },
  }

};
</script>

<style scoped>
.img {
  display: flex;
  align-items: center;
}

.img > img {
  margin-right: 10px;
}
</style>